import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AppUploadFilesComponent } from './app-upload-files.component';

// `HttpClientModule` n'est volontairement importé que dans `AppModule` : le ré-importer ici
// redéclarerait `HTTP_INTERCEPTORS` (via `HttpClientXsrfModule`) dans l'injecteur d'un module
// lazy, ce qui masquerait les intercepteurs de la racine (credentials + refresh JWT).
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [AppUploadFilesComponent],
  exports: [AppUploadFilesComponent],
})
export class AppUploadFilesModule { }



// WEBPACK FOOTER //
// ./src/app/components/app-upload-files/app-upload-files.module.ts